"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.bind");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var VerticalCarousel = /*#__PURE__*/function (_React$Component) {
  _inherits(VerticalCarousel, _React$Component);

  var _super = _createSuper(VerticalCarousel);

  function VerticalCarousel(props) {
    var _this;

    _classCallCheck(this, VerticalCarousel);

    _this = _super.call(this, props);
    _this.rotateCarousel = _this.rotateCarousel.bind(_assertThisInitialized(_this));
    _this.state = {
      rotationCount: 0
    };
    return _this;
  }

  _createClass(VerticalCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.intervalId = setInterval(this.rotateCarousel, this.props.cycleRate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
    }
  }, {
    key: "rotateCarousel",
    value: function rotateCarousel() {
      this.setState({
        // eslint-disable-next-line react/no-access-state-in-setstate -- directive added automatically by Shepherd migration
        rotationCount: this.state.rotationCount + 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var numberInRotation = 3; // Showing only 3 values in carousel makes rotation effect more dramatic

      var rotationDistribution = 360 / numberInRotation;
      var radius = Math.round(this.props.height / 2 / Math.tan(Math.PI / numberInRotation));
      var figureTranslation = "".concat(radius, "px");
      var carouselRotation = this.state.rotationCount * rotationDistribution;
      var carouselTransformStyle = "translateZ(".concat(radius * -1, "px) rotateX(").concat(carouselRotation, "deg)");
      var carouselStyle = {
        transform: carouselTransformStyle,
        WebkitTransform: carouselTransformStyle,
        msTransform: carouselTransformStyle,
        MozTransform: carouselTransformStyle
      };
      var elemToShow = this.state.rotationCount % this.props.elements.length;
      var elemToShowBefore = elemToShow - 1 < 0 ? this.props.elements.length - 1 : elemToShow - 1;
      var elemToShowAfter = elemToShow + 1 >= this.props.elements.length ? 0 : elemToShow + 1;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "vertical-carousel-container",
        style: {
          height: this.props.height
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "vertical-carousel",
        style: carouselStyle
      }, this.props.elements.map(function (element, index) {
        var display = 'none';
        var rotation = 0;

        if (index === elemToShow) {
          rotation = carouselRotation * -1;
          display = 'block';
        } else if (index === elemToShowBefore) {
          rotation = carouselRotation * -1 + rotationDistribution;
          display = 'block';
        } else if (index === elemToShowAfter) {
          rotation = carouselRotation * -1 - rotationDistribution;
          display = 'block';
        }

        var transformStyle = "rotateX(".concat(rotation, "deg) translateZ(").concat(figureTranslation, ")");
        var style = {
          transform: transformStyle,
          WebkitTransform: transformStyle,
          msTransform: transformStyle,
          MozTransform: transformStyle,
          height: _this2.props.height,
          display: display
        };
        /* eslint-disable react/no-array-index-key */

        return /*#__PURE__*/_react["default"].createElement("figure", {
          key: index,
          style: style
        }, element);
        /* eslint-enable react/no-array-index-key */
      })));
    }
  }]);

  return VerticalCarousel;
}(_react["default"].Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


VerticalCarousel.propTypes = {
  elements: _propTypes["default"].arrayOf(_propTypes["default"].node).isRequired,
  cycleRate: _propTypes["default"].number,
  height: _propTypes["default"].number.isRequired
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

VerticalCarousel.defaultProps = {
  cycleRate: 2000
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

VerticalCarousel.displayName = 'VerticalCarousel';
var _default = VerticalCarousel;
exports["default"] = _default;